export default __webpack_public_path__ + "static/media/img_muslinTwoBibsTwo_yg.8f0fa2e4.jpg";